import { Path, Permission } from "enums";
import PriceMovementModule from "modules/price-movement/price-movement.module";
import PriceMovementAddModule from "modules/price-movement/price-movement-add/price-movement-add.module";
import PriceMovementEditModule from "modules/price-movement/price-movement-edit/price-movement-edit.module";
import { PermissionRoute } from "components/commons";
import React from "react";
import { Redirect } from "react-router-dom";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom.min";

const PriceMovementPage = () => {
  return (
    <Switch>
      <Route exact path={Path.PriceMovementList} component={PriceMovementModule} />
      <PermissionRoute
        exact
        path={Path.AddPriceMovement}
        permission={Permission.PriceMovementCreate}
        redirectTo={Path.PriceMovementList}
        component={PriceMovementAddModule}
      />
      <PermissionRoute
        exact
        path={Path.EditPriceMovement}
        permission={Permission.PriceMovementEdit}
        redirectTo={Path.PriceMovementList}
        component={PriceMovementEditModule}
      />
      <Redirect to={Path.PriceMovementList} />
    </Switch>
  );
};

export default PriceMovementPage;
